module.exports = __webpack_public_path__ + "static/banner-update-data-ar-MB-11e8079c71aec858ad2148c8213c49c8.png";